import { useEffect, useState } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
import { getGasTipFromMaxGasFee } from '../../utils'

export function useGasPriceForEthMax(networkBaseFee?: BigNumber) {
  const [maxGasFeeForEthMax, setMaxGasFeeForEthMax] = useState<BigNumber>()
  const [maxGasTipForEthMax, setMaxGasTipForEthMax] = useState<BigNumber>()

  useEffect(() => {
    if (!maxGasFeeForEthMax || !networkBaseFee) {
      setMaxGasTipForEthMax(undefined)
      return
    }
    setMaxGasTipForEthMax(getGasTipFromMaxGasFee(maxGasFeeForEthMax, networkBaseFee))
  }, [maxGasFeeForEthMax, networkBaseFee])

  return { maxGasFeeForEthMax, maxGasTipForEthMax, setMaxGasFeeForEthMax }
}
